import { Notification, type NotificationProps } from "@/models/notification";
import { ref } from "vue";
import { type WretchError } from "wretch";

function isError(err: unknown): err is WretchError {
  if (err && typeof err === "object" && "response" in err) {
    console.debug("[isError] err is WretchError:", err);
    return true;
  } else {
    console.debug("[isError] err is not WretchError:", err);
  }
  return false;
}

class NotificationsService {
  readonly state = ref({
    notifications: new Array<Notification>(),
  });

  open(props: NotificationProps): void {
    const notification = new Notification(props);
    this.state.value.notifications.push(notification);
    setTimeout(() => this.close(notification.id), notification.timeout);
    if (notification.error) {
      console.error("Notify error", notification.error);
    }
  }

  error(error: unknown): void {
    console.log("Notify error", error);
    if (isError(error)) {
      notificationsService.open({
        text: error.response.statusText,
        type: "error",
      });
    } else {
      notificationsService.open({
        text: "Ett okänt fel har inträffat.",
        type: "error",
      });
    }
  }

  close(id: string): void {
    const index = this.state.value.notifications.findIndex((n) => n.id === id);
    if (index >= 0) {
      this.state.value.notifications.splice(index, 1);
    }
  }
}

export const notificationsService = new NotificationsService();
